// extracted by mini-css-extract-plugin
export default {"reportCard":"DownloadReportCard_reportCard__pFmqs"};